<template>
    <div class="form-group">
        <label>{{ name }}</label>
        <chosen-multiselect
            :id="'filter_' + id"
            :name="'filter_' + id"
            v-model='valueInner'
            >
            <option v-for="optiondata in value" :value="optiondata.id">
              {{ optiondata.text }}
            </option>
        </chosen-multiselect>
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value'],
        data: function() {
            return {
               valueInner: [],
            }
        },
        watch: {
            value: function(val,oldVal) {
                val = parseInt(val);
                this.calcInnerValues(val);
            },
            valueInner: function(val,oldVal) {
                EaseEventBus.fire('resetExistingFilters');
                //this.$emit('input',val);
                for (var index in val) {
                    val[index] = parseInt(val[index]);
                }

                for (var index in this.value) {
                    this.value[index].value = false;
                    if (val.indexOf(this.value[index].id) > -1) {
                        this.value[index].value = true;
                    }
                }
                this.$emit('input',this.value);
            }
        },
        methods: {
            calcInnerValue: function(val) {
                var list = [];
                for (var v in val) {
                    if (val[v].value === true) {
                        list.push(parseInt(val[v].id));
                    }
                }

                this.valueInner = list;
            }
        },
        mounted() {
            this.calcInnerValue(this.value);
        }
    }
</script>
